module.exports = __webpack_public_path__ + "img/apio.cfb730af.svg";